<template>
	<section id="info-box">
		<header class="masthead">
			<div class="logo flex">
				<!-- <img src="../assets/logo.png" /> -->
				<svg
					viewBox="0 0 24 24"
					fill="none"
					stroke-width="2"
					stroke-linecap="round"
					stroke-linejoin="round"
				>
					<path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
					<polyline points="22,6 12,13 2,6" />
				</svg>
				<span>Mail Invicta</span>
			</div>
		</header>
		<div class="info-box box">
			<div class="container">
				<div class="mailbox flex flex-space-between flex-sm">
					<button
						type="button"
						class="btn plain"
						title="Generate new Mailbox"
						@click="$bus.newMailbox()"
					>
						<svg
							viewBox="0 0 24 24"
							fill="none"
							stroke="#f5817a"
							stroke-width="2"
							stroke-linecap="round"
							stroke-linejoin="round"
							class="new-mailbox"
						>
							<polyline points="22 12 16 12 14 15 10 15 8 12 2 12" />
							<path
								d="M5.45 5.11L2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z"
							/>
						</svg>
						<span>New Mailbox</span>
					</button>
				</div>
				<div class="sessions">
					<div class="session-wrap">
						<div
							class="session"
							v-for="(session, index) in this.$bus.sessions"
							:key="index"
							@click="$bus.setMailbox(session)"
							:class="{current: session.mailbox == $bus.email.mailbox}"
						>
							<span class="name">{{session.name}}</span>
							<span class="email">{{ session.mailbox.toLowerCase() }}@mailinvicta.com</span>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
export default {
	name: "InfoBox",
	data() {
		return {
			copied: false
		};
	},
	methods: {}
};
</script>

<style lang="scss">
#info-box {
	flex: 0 1 25%;

	.masthead {
		border-right: 1px solid rgba(255, 255, 255, 0.1);
	}
	.info-box {
		height: calc(100% - 60px);
		border-right: 1px solid var(--border);

		.mailbox {
			text-align: center;
			padding: 20px;
			border-bottom: 1px solid var(--border);
			.btn {
				margin: 0 auto;
			}
			svg {
				width: 24px;
			}
		}
		.session-wrap {
			font-size: 0.8rem;
			.session {
				border-left: 3px solid transparent;
				border-bottom: 1px solid var(--border);
				padding: 10px 20px;

				cursor: pointer;
				line-height: 1.6;

				span {
					display: block;

					&.name {
						font-weight: 600;
			letter-spacing: .5px;
					}
				}
				// &:not(:last-child) {
				//   border-right: 1px solid #ccc;
				// }

				&.current {
					background: var(--active-back);
					border-left-color: #f5817a;
					&:before {
						content: "";
						display: block;
					}
				}
			}
		}
	}

}
</style>